import React, { useState } from 'react';
import Hero from '../components/home/Hero';
import ModelFeatures from '../components/home/ModelFeatures';
import BenefitsList from '../components/home/BenefitsList';
import CallToAction from '../components/home/CallToAction';
import RequestDemo from '../components/merchants/RequestDemo';

const Home: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-dark min-h-screen w-full">
      <Hero />
      <ModelFeatures />
      <BenefitsList />
      <CallToAction onRequestDemo={() => setIsModalOpen(true)} />
      <RequestDemo 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Home;